import "core-js/stable";
import "regenerator-runtime/runtime";

import 'isomorphic-fetch';

import queryString from 'query-string';
window.queryString = queryString;

import User from './components/User';
window.User = User;